if (!customElements.get('load-more')) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();

      // Set scroll restoration to manual to prevent browser from overriding custom scroll behavior
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }

      // Global identifiers
      this.targetId = this.dataset.loaderTargetId;
      this.targetWrapper = '[data-loader-target="' + this.targetId + '"]';
      this.targetListArr = '[data-loader-list]';
      this.template = document.querySelector(this.targetWrapper).dataset.loaderTemplate;
      this.isBlog = this.dataset.blog;
      this.paginationPrevAttr = '[data-pagination-prev]';
      this.paginationNextAttr = '[data-pagination-next]';
      this.forward = {};
      this.backward = {};
      this.infiniteLoad = this.dataset.infiniteLoad;
      if (this.infiniteLoad) {
        this.initInfiteLoad();
        this.seconds = 3;
        this.interval = '';
      }

      this.initPagination();
    }

    initPagination() {
      // Catch clicks
      this.addEventListener('click', (e) => {
        // if click is on [data-load-button]
        if (e.target.closest('[data-load-button]')) {
          this.showContent(e);
        }
        // if click is on a link
        if (e.target.closest('[href]')) {
          const clickedItem = e.target.closest('[href]');
          if (clickedItem.dataset.loadButton) {
            return;
          }
          localStorage.setItem('clickedItemHref', clickedItem.getAttribute('href'));
        }
      });

      // Pre-fetch content from the buttons
      let that = this;
      this.querySelectorAll('[data-load-button]').forEach((button) => {
        that.loadContent(button);
      });

      // Scroll to the last clicked item if it is stored in local storage
      let clickedItemHref = localStorage.getItem('clickedItemHref');
      if (clickedItemHref !== null) {
        // Remove URL parameters using URL constructor
        const url = new URL(clickedItemHref, window.location.origin);
        clickedItemHref = url.pathname;
        const clickedItem = document.querySelector(`.product-card__image[href="${clickedItemHref}"]`);
        if (clickedItem) {
          // Use setTimeout to ensure DOM is ready and prevent browser scroll restoration conflicts
          setTimeout(() => {
            clickedItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
            localStorage.removeItem('clickedItemHref');
          }, 100);
        }
      }
    }

    initInfiteLoad() {
      let that = this;
      let el = document.querySelector('[data-load-direction="next"]');
      let observer = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            let spans = el.querySelectorAll('span');
            spans[0].hidden = true;
            spans[1].hidden = false;
            let cancel = el.closest('[data-buttons]').querySelector('[data-cancel]');
            this.interval = setInterval(incrementSeconds, 1000);
            cancel.addEventListener('click', () => {
              clearInterval(this.interval);
              spans[0].hidden = false;
              spans[1].hidden = true;
              spans[0].closest('[data-buttons]').classList.remove('is-loading');
              this.seconds = 3;
            });
            return;
          }
        },
        {
          root: null,
          threshold: 0.9, // set offset 0.1 means trigger if atleast 10% of element in viewport
        }
      );

      function incrementSeconds() {
        if (that.seconds == 1) {
          document.querySelector('[data-load-direction="next"]').click();
          clearInterval(that.interval);
          return;
        }
        if (that.seconds == 3) {
          document
            .querySelector('[data-load-direction="next"]')
            .closest('[data-buttons]')
            .classList.add('is-loading');
        }
        that.seconds = parseInt(that.seconds) - 1;
        document.querySelector('[data-load-direction="next"]');
        let spans = el.querySelectorAll('span');
        let data = spans[1].dataset.string;
        spans[1].innerText = data + ' | ' + that.seconds + 's ...';
      }

      observer.observe(el);
    }

    updatePagination(
      direction,
      existingLoadPrev,
      fetchedLoadPrev,
      existingLoadNext,
      fetchedLoadNext
    ) {
      if (direction === 'next') {
        existingLoadNext.innerHTML = fetchedLoadNext.innerHTML;
      } else {
        existingLoadPrev.innerHTML = fetchedLoadPrev.innerHTML;
      }
    }

    loadContent(event) {
      // Destructure to get what we need
      const currentTarget = event;
      let href = event.href;

      // Get full url and get current search params
      const url = new URL(`${href}`);
      const params = new URLSearchParams(url.search);

      // Set of overwrite url view parameter
      if (this.isBlog == 'false' || !this.isBlog) {
        params.set('view', this.template);
      }

      // New url to fetch
      const newUrl = ` ${url.origin}${url.pathname}?${params.toString()}`;

      // Prev or next page?
      const direction = currentTarget.dataset.loadDirection;

      // Update interface elements
      currentTarget.querySelector('[data-load-text]').hidden = true;
      currentTarget.querySelector('[data-loader]').hidden = false;

      // Fetch the products
      this.fetchContent(newUrl, href, direction, currentTarget);
    }

    /**
     * updateURLHash
     * @param {String} url
     */
    updateURLHash(url) {
      history.pushState('', '', url);
    }

    showContent(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      let direction = event.target.dataset.loadDirection;
      if (typeof direction === 'undefined') {
        direction = event.target.closest('[data-load-button]').dataset.loadDirection;
      }
      this.object = this.backward;

      if (direction == 'next') {
        this.object = this.forward;
      }

      // Add the products to the existing list
      setTimeout(() => {
        direction === 'next'
            ? this.forward.existingProductsList.append(this.forward.fetchedContent)
            : this.backward.existingProductsList.prepend(this.backward.fetchedContent);
      });

      // Perform heavy operations after browser has painted
      setTimeout(() => {
        this.updatePagination(
          this.object.direction,
          this.object.existingLoadPrev,
          this.object.fetchedLoadPrev,
          this.object.existingLoadNext,
          this.object.fetchedLoadNext
        );

        // Re-init pagination. Otherwise it won't work
        this.initPagination();

        // update url
        this.updateURLHash(this.object.href);

        // Re-init infinite Load
        if (this.infiniteLoad) {
          this.seconds = 3;
          this.initInfiteLoad();
        }
      }, 10);
    }

    /**
     * fetchContent
     * @description Renders the products based on the fetch url data.
     * @param {String} url
     * @param {String} page
     * @param {String} direction
     */
    async fetchContent(url, href, direction, currentTarget) {
      try {
        // Fetch content
        const response = await fetch(url);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        // Return if wrapper is not found
        if (!html.querySelector(this.targetWrapper)) return;

        if (direction == 'next') {
          this.forward.existingProductsList = this.querySelector(this.targetListArr);
          this.forward.existingLoadPrev = this.querySelector(this.paginationPrevAttr);
          this.forward.existingLoadNext = this.querySelector(this.paginationNextAttr);
          this.forward.fetchedContentList = html.querySelector(this.targetListArr);
          this.forward.fetchedContent = document
            .createRange()
            .createContextualFragment(this.forward.fetchedContentList.innerHTML);
          let titleArr = this.forward.fetchedContent.querySelectorAll('[data-search-title]');
          titleArr.forEach((title) => {
            title.classList.add('hidden');
          });
          this.forward.fetchedLoadPrev = html.querySelector(this.paginationPrevAttr);
          this.forward.fetchedLoadNext = html.querySelector(this.paginationNextAttr);
          this.forward.direction = direction;
          this.forward.href = href;
        } else {
          this.backward.existingProductsList = this.querySelector(this.targetListArr);
          this.backward.existingLoadPrev = this.querySelector(this.paginationPrevAttr);
          this.backward.existingLoadNext = this.querySelector(this.paginationNextAttr);
          this.backward.fetchedContentList = html.querySelector(this.targetListArr);
          this.backward.fetchedContent = document
            .createRange()
            .createContextualFragment(this.backward.fetchedContentList.innerHTML);
          this.backward.fetchedLoadPrev = html.querySelector(this.paginationPrevAttr);
          this.backward.fetchedLoadNext = html.querySelector(this.paginationNextAttr);
          this.backward.direction = direction;
          this.backward.href = href;
        }

        currentTarget.querySelector('[data-loader]').hidden = true;
        currentTarget.querySelector('[data-load-text]').hidden = false;
      } catch (error) {
        console.log(error);
      }
    }
  }

  window.LoadMore = LoadMore;
  customElements.define('load-more', LoadMore);
}
